import { Typography } from '@automata/ui';
import Box from '@mui/material/Box';
import { lighten } from '@mui/material/styles';
import { Position } from 'reactflow';

import {
  SOURCE_HANDLE_IDENTIFIER,
  TARGET_HANDLE_IDENTIFIER,
} from '../../../../constants';
import { LabwareDataForTask } from '../../../../types';
import {
  getColorFromIndex,
  serializeLabwareHandlePairId,
} from '../../../../utils';
import { colorLightenFactor } from '../../../styles';
import Handle from '../../Handle';

type Props = {
  data: LabwareDataForTask;
  hasDeadEnd: boolean;
  handlePairId: string;
};

const ExistingLabwareSection = ({
  hasDeadEnd,
  handlePairId,
  data: { colorIndex, labwareName },
}: Props) => {
  const color = getColorFromIndex(colorIndex);
  // In the case of labware dependency edges from connector, the handlePairId is postfixed with the id, e.g. "source.1"
  const realHandlePairId = handlePairId.split('.')[0] ?? '';

  return (
    <Box position="relative">
      <Box
        borderRadius={1}
        sx={{
          backgroundColor: lighten(color, colorLightenFactor),
        }}
      >
        <Typography
          variant="h6"
          textAlign="center"
          padding="0.25rem 0.75rem"
          noWrap
        >
          {labwareName}
        </Typography>
      </Box>
      <Handle
        id={serializeLabwareHandlePairId(
          TARGET_HANDLE_IDENTIFIER,
          realHandlePairId
        )}
        type="source"
        position={Position.Top}
        style={{ borderColor: color, top: -25 }}
      />
      {hasDeadEnd ? null : (
        <Handle
          id={serializeLabwareHandlePairId(
            SOURCE_HANDLE_IDENTIFIER,
            handlePairId
          )}
          type="source"
          position={Position.Bottom}
          style={{
            borderColor: color,
            bottom: -25,
          }}
        />
      )}
    </Box>
  );
};

export default ExistingLabwareSection;
